import React from 'react';
import styles from './Spinner.css';

const Spinner = ({ text }) => (
  <div className={styles.Loader}>{text || 'Loading...'}</div>
);

export default Spinner;

